import { NgModule } from '@angular/core';
import { RelativeTimePipe } from '../timePassedPipe';
import { LikeCountPipe } from '../numberOfLikesPips';
import { OthersFeedOptionsDialogComponent } from '../others-feed-options-dialog/others-feed-options-dialog.component';
import { ReportDialogComponent } from '../report-dialog/report-dialog.component';
import { InsightsDialogComponent } from '../insights-dialog/insights-dialog.component';
import { LikesListDialogComponent } from '../likes-list-dialog/likes-list-dialog.component';
import { EditPostDialogComponent } from '../edit-post-dialog/edit-post-dialog.component';
import { FeedOptionsDialogComponent } from '../feed-options-dialog/feed-options-dialog.component';
import { PostDetailsPopUpComponent } from '../post-details-pop-up/post-details-pop-up.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { BoostPostDialogComponent } from '../insights-dialog/boost-post-dialog/boost-post-dialog.component';
import {MatSliderModule} from '@angular/material/slider';
import {MatRadioModule} from '@angular/material/radio';
import { OptionsForModComponent } from '../options-for-mod/options-for-mod.component';






@NgModule({
    declarations: [
        RelativeTimePipe,
        LikeCountPipe,
        OthersFeedOptionsDialogComponent,
        OptionsForModComponent,
        ReportDialogComponent,
        InsightsDialogComponent,
        LikesListDialogComponent,
        PostDetailsPopUpComponent,
        FeedOptionsDialogComponent,
        EditPostDialogComponent,
        BoostPostDialogComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        MatFormFieldModule,
        MatRadioModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatSliderModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        SlickCarouselModule,
        ClipboardModule
    ],
    exports: [
        RelativeTimePipe,
        LikeCountPipe,
        OthersFeedOptionsDialogComponent,
        OptionsForModComponent,
        ReportDialogComponent,
        InsightsDialogComponent,
        LikesListDialogComponent,
        PostDetailsPopUpComponent,
        FeedOptionsDialogComponent,
        EditPostDialogComponent,
        BoostPostDialogComponent
    ],
})
export class SharedSocialComps { }
